<template>
    <div id="app">
        <div class="spinner-wrapper">
            <div class="spinner">
                <div class="rect1" />
                <div class="rect2" />
                <div class="rect3" />
                <div class="rect4" />
                <div class="rect5" />
            </div>
        </div>
        
        <alert-bar />
        <!-- <DialogRoot /> -->
        <router-view />
    </div>
</template>

<script>
import DialogRoot from "@/smallComponents/Dialog/DialogRoot";

export default {
    name: "App",
    components: {
        DialogRoot
    },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue